import { DefaultTheme } from '../../components/theme';

export const CSS = {
	container: 'c-TagList',
	tag: 'c-TagList__item',
	loadmore: 'c-TagList__loadmore',
	cards: {
		container: 'c-TagList__cards',
		head: 'c-TagList__cards-header',
		isEmpty: 'c-TagList__cards--empty',
	},
	collections: {
		container: 'c-TagList__collections',
	},
	empty: {
		message: 'c-TagListEmpty__message',
		reset: 'c-TagListEmpty__reset',
	},
};

export const Style = {
	[CSS.container]: {
		fontFamily: DefaultTheme.font.familyCondensed,
		position: 'relative',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		height: '100%',
		boxShadow: DefaultTheme.shadow.box.dp4,
		minWidth: '20%',
	},
	[CSS.cards.container]: {
		overflowY: 'auto',
		height: '100%',
	},
	[CSS.cards.isEmpty]: {
		display: 'flex',
		'flex-direction': 'column',
		'justify-content': 'center',
		'align-items': 'center',
	},
	[CSS.loadmore]: {
		width: '100%',
		display: 'flex',
		'justify-content': 'center',
	},
	[CSS.cards.head]: {
		display: 'flex',
		justifyContent: 'space-around',
		boxShadow: DefaultTheme.shadow.box.dp4,
	},
	[CSS.empty.reset]: {
		cursor: 'pointer',
		color: DefaultTheme.color.accent,
	},
};
